import './HowTo.scss';
import { useContext } from 'react';
import { Navbar } from '../components/micro/NavBar/NavBar';
import { PortContext } from '../service/MessageChannelContext';
import { Card } from '../components/micro/Card/Card';

import Step1 from '../images/howto-step1.png';
import Step2 from '../images/howto-step2.png';
import Step3 from '../images/howto-step3.png';
import Step4 from '../images/howto-step4.png';
import { List } from '../components/micro/List/List';
import { Button } from '../components/micro/Button/Button';
import { useNavigate } from 'react-router-dom';

const CONTENT = {
  instructionsTitle: {
    en: 'How to take a perfect selfie',
    id: 'How to take a perfect selfie',
  },
  step1: {
    en: 'Step 1',
    id: 'Langkah 1',
  },
  step2: {
    en: 'Step 2',
    id: 'Langkah 2',
  },
  step3: {
    en: 'Step 3',
    id: 'Langkah 3',
  },
  step4: {
    en: 'Step 4',
    id: 'Langkah 4',
  },
  step1Content: {
    en: 'Remove your glasses and makeup.',
    id: 'Lepas kaca mata dan hapus makeup-mu.',
  },
  step2Content: {
    en: 'Stand in a well lit area and ensure there are no shadows on your face.',
    id: 'Berdiri di area terang dan pastikan nggak ada bayangan di wajahmu.',
  },
  step3Content: {
    en: "If you're wearing headscarf, adjust your headscarf so it’s not covering or creating shadow on your face.",
    id: 'Kalau kamu berhijab, atur hijabmu biar nggak menutupi atau membuat bayangan di wajah.',
  },
  step4Content: {
    en: 'Use a neutral expression (no smiling) and align your face in the oval',
    id: 'Tunjukkan ekspresi natural (jangan senyum) dan sesuaikan wajah dalam lingkaran.',
  },
  privacyPolicy: {
    en: 'By using "Emina AI Skin Analysis", you agree to our Privacy Policy and Terms of Use.',
    id: 'Dengan menggunakan "AI Skin Analysis Emina", berarti kamu menyetujui Kebijakan Privasi dan Ketentuan Penggunaan.',
  },
  readyButton: {
    en: 'Ok, I’m Ready',
    id: 'Oke, Aku Siap',
  },
};

const Howto = () => {
  const { lang } = useContext(PortContext);
  const navigate = useNavigate();
  return (
    <div className="how-to">
      <Navbar />
      <Card title={CONTENT.instructionsTitle[lang]}>
        <List
          isFlex
          items={[
            {
              image: Step1,
              title: CONTENT.step1[lang],
              description: CONTENT.step1Content[lang],
            },
            {
              image: Step2,
              title: CONTENT.step2[lang],
              description: CONTENT.step2Content[lang],
            },
            {
              image: Step3,
              title: CONTENT.step3[lang],
              description: CONTENT.step3Content[lang],
            },
            {
              image: Step4,
              title: CONTENT.step4[lang],
              description: CONTENT.step4Content[lang],
            },
          ]}
        />
        <div className="holder">
          <hr />
        </div>

        <div className="privacy-policy">{CONTENT.privacyPolicy[lang]}</div>
        <div className="holder">
          <Button text={CONTENT.readyButton[lang]} onClick={() => navigate('/openCamera')} />
        </div>
      </Card>
    </div>
  );
};

export default Howto;
